import { CancelBooking, Loader, PayAmountWithQRCode } from 'components';
import {
  AppBar,
  Button,
  Container,
  Divider,
  Toolbar,
  Typography,
} from '@mui/material';
import cancelSVG from 'assets/images/cancel.svg';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetBookingDetails } from 'hooks/useBooking';

export const PaymentQRCode = () => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleBackClick = () => {
    setOpen(true);
  };

  const { bookingId } = useParams();

  const {
    data: bookingData,
    isError: getBookingError,
    isLoading: isBookingLoading,
  } = useGetBookingDetails(bookingId);

  useEffect(() => {
    if (getBookingError) {
      toast.error(getBookingError);
    }
  }, [getBookingError]);

  if (isBookingLoading) return <Loader />;
  const price = bookingData ? bookingData.TotalAmount.toFixed(2) : 0;
  return open ? (
    <CancelBooking open={open} handleClose={handleClose} />
  ) : (
    <>
      <Container>
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backgroundColor: 'unset',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar>
            <Button sx={{ position: 'absolute' }} onClick={handleBackClick}>
              <img src={cancelSVG} width={100} />
            </Button>
            <Typography
              className="navbarTitle"
              color="primary"
              component="p"
              sx={{ fontWeight: 500 }}
            >
              {`SCAN `}
              <span style={{ textDecoration: 'underline', fontWeight: '700' }}>
                QR CODE & PAY
              </span>
            </Typography>
          </Toolbar>
        </AppBar>
      </Container>
      <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />

      <Container
        sx={{ height: 'calc(100vh - 65px)', overflow: 'auto', display: 'flex' }}
      >
        <PayAmountWithQRCode
          days={bookingData?.RentalDuration ?? 0}
          price={price}
        />
      </Container>
    </>
  );
};
